module.exports = __webpack_public_path__ + "media/images/instagram2x-2f234a2a698789fd3f9d24e7a373a9b8.png";